import { type ComponentProps, type ReactNode } from "react";
import { VStack } from "@design-system/VStack/VStack";
import styles from "./ScheduleManualModal.module.scss";

interface ScheduleManualLabeledFieldProps {
    label: string;
    /** Lets a control inside name itself with `aria-labelledby`. */
    labelId?: string;
    gap?: ComponentProps<typeof VStack>["gap"];
    children: ReactNode;
}

export const ScheduleManualLabeledField = ({
    label,
    labelId,
    gap = 6,
    children,
}: ScheduleManualLabeledFieldProps) => (
    <VStack gap={gap} align="start">
        <span id={labelId} className={styles.fieldLabel}>
            {label}
        </span>
        {children}
    </VStack>
);
